import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {TrackEntity, TrackState} from '@spout/global-any/models';

export const trackAdapter: EntityAdapter<TrackEntity> =
  createEntityAdapter<TrackEntity>();

export const initialTrackState: TrackState = trackAdapter.getInitialState({
  // additional entity state properties
});
